// extracted by mini-css-extract-plugin
module.exports = {"container":"NewOfficeModal_container__ss0AH","title":"NewOfficeModal_title__2w7op","body":"NewOfficeModal_body__2QEoB","buttons":"NewOfficeModal_buttons__1ePv4"};